import type { FC } from 'react';
import { useInspectedTracker } from '../../../lib/customHooks';
import { TrackerSettingsInfos } from '../TrackerSettingsInfos';

export const SettingsTab: FC = () => {
  const inspectedTracker = useInspectedTracker();
  if (inspectedTracker == null) return <></>;

  return <TrackerSettingsInfos tracker={inspectedTracker} />;
};
